// components/HasPermission.jsx
import React from 'react';
import { useAuthStore } from '../store/authStore';

const HasPermission = ({ allowedRoles = [], children }) => {
  const { user } = useAuthStore();
  const userRole = user?.role?.toLowerCase();

  // Guard against undefined allowedRoles or missing user role
  if (!allowedRoles || !Array.isArray(allowedRoles) || !userRole) {
    return null;
  }

  const hasAccess = allowedRoles.includes(userRole);

  return hasAccess ? <>{children}</> : null;
};

export default HasPermission;